import { render, staticRenderFns } from "./navigation-item.vue?vue&type=template&id=4d60fbec&scoped=true&"
import script from "./navigation-item.vue?vue&type=script&lang=js&"
export * from "./navigation-item.vue?vue&type=script&lang=js&"
import style0 from "./navigation-item.vue?vue&type=style&index=0&id=4d60fbec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60fbec",
  null
  
)

export default component.exports